import { createSelector, createFeatureSelector } from '@ngrx/store';
import {  } from './navigation.actions';
import { BaseState } from '../../base.state';

export const selectNavigationState = createFeatureSelector<BaseState>('navigation');

export const selectNavigation = createSelector(
  selectNavigationState,
    (state: BaseState) => state
);
